class GzToast extends HTMLElement {
  connectedCallback() {
    this.cacheElements();
    this.attachListeners();
  }

  cacheElements() {
    this.closeButton = this.querySelector('.gz-toast__close');
  }

  attachListeners() {
    this.closeButton?.addEventListener('click', () => {
      this.hide();
    });
  }

  show() {
    this.classList.add('show');
  }

  hide() {
    this.classList.remove('show');
  }

  toggle() {
    this.classList.toggle('show');
  }
}
customElements.define('gz-toast', GzToast);

// Global Toast Helper
window.GzToastHelper = {
  find(identifier = 0) {
    if (typeof identifier === 'number') {
      const toasts = document.querySelectorAll('gz-toast');
      return toasts[identifier] || null;
    }
    return document.querySelector(identifier);
  },

  show(identifier = 0) {
    const toast = this.find(identifier);
    if (toast) toast.show();
  },

  hide(identifier = 0) {
    const toast = this.find(identifier);
    if (toast) toast.hide();
  },

  toggle(identifier = 0) {
    const toast = this.find(identifier);
    if (toast) toast.toggle();
  },

  showAll() {
    document.querySelectorAll('gz-toast').forEach(toast => toast.show());
  },

  hideAll() {
    document.querySelectorAll('gz-toast').forEach(toast => toast.hide());
  }
};